import React from "react";
import { Link } from "react-router-dom";
import "./CSS/ContactHero.css";
import bannerImg from "./IMAGES/Rectangle 1 (1).png";

const ContactHero = () => {
  return (
    <div className="conatct-banner">
      <img src={bannerImg} alt="conatct-banner" />

      <div className="conatct-overlay">
        <h1>Contact</h1>
        <p>
          <Link to="/">Home</Link> <span>›</span>{" "}
          <span className="conatct-active">Contact</span>
        </p>
      </div>
    </div>
  );
};

export default ContactHero;
